// Utility for handling array query params that require [] suffix

export const ARRAY_PARAMS_WITH_SUFFIX = ['competitorTargetTypes', 'tagNames'] as const

export type ArrayParamWithSuffix = (typeof ARRAY_PARAMS_WITH_SUFFIX)[number]

/**
 * Returns true if the given key should use [] suffix for array query params.
 */
export function isArrayParamWithSuffix(key: string): boolean {
  return (ARRAY_PARAMS_WITH_SUFFIX as readonly string[]).includes(key)
}

/**
 * Returns the correct param key for an array value, applying [] when needed.
 */
export function paramKeyForArray(key: string): string {
  return isArrayParamWithSuffix(key) ? `${key}[]` : key
}
